<rt-divider margin-bottom-small />

<div class="signature-wrapper">
  <span>{{ 'app.spam_verification.fixed_footer.prefix' | translate }}</span>
  <img
    class="logo"
    [src]="
      threadTheme() === 'light'
        ? 'assets/images/email_footer_logo_light.png'
        : 'assets/images/email_footer_logo_dark.png'
    "
    alt="logo"
  />
  <span>{{ 'app.spam_verification.fixed_footer.suffix' | translate }} </span>
</div>
